class GiftRecipientForm extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId ?? '';
    this.errorEl = this.querySelector('[data-error]');
    this.cardNote = this.querySelector('[data-card-note]');
    this.charCount = this.querySelector('[data-char-count]');

    this.cardNote?.addEventListener('input', this.#updateCharCount);
    this.#updateCharCount();
  }

  disconnectedCallback() {
    this.cardNote?.removeEventListener('input', this.#updateCharCount);
  }

  /** @returns {Promise<boolean>} */
  async validateBeforeAdd() {
    if (!this.#validate()) {
      return false;
    }

    await window.DeliveryCheckoutSync?.syncFromProductForm?.(this.formId);
    return true;
  }

  #updateCharCount = () => {
    if (!(this.cardNote instanceof HTMLTextAreaElement) || !this.charCount) return;

    const max = this.cardNote.maxLength > 0 ? this.cardNote.maxLength : 200;
    this.charCount.textContent = `${this.cardNote.value.length} / ${max}`;
  };

  /** @returns {boolean} */
  #validate() {
    const invalidField = this.querySelector(':invalid');

    if (invalidField instanceof HTMLElement) {
      if (this.errorEl) {
        this.errorEl.hidden = false;
        this.errorEl.textContent = 'Lütfen gönderici, alıcı ve teslimat bilgilerini eksiksiz doldurun.';
      }

      invalidField.focus();
      invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    if (this.errorEl) {
      this.errorEl.hidden = true;
    }

    return true;
  }
}

if (!customElements.get('gift-recipient-form')) {
  customElements.define('gift-recipient-form', GiftRecipientForm);
}
